import type { SVGProps } from "react";
const SvgGitlab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#E24329"
      d="m240.136 104.664-.312-.836-31.576-82.581a8.2 8.2 0 0 0-3.247-3.927 8.33 8.33 0 0 0-10.653 1.4 8.4 8.4 0 0 0-1.874 3.378L171.16 87.521H84.847L63.533 22.098a8.4 8.4 0 0 0-1.878-3.373 8.36 8.36 0 0 0-7.008-2.673 8.34 8.34 0 0 0-3.64 1.268 8.2 8.2 0 0 0-3.247 3.927L16.2 103.843l-.328.821a58.92 58.92 0 0 0-1.595 37.224 58.78 58.78 0 0 0 21.047 30.707l.12.09.268.209 48.034 36.093 23.831 18.055 14.478 10.976a9.77 9.77 0 0 0 11.796 0l14.477-10.976 23.831-18.055 48.377-36.302.134-.105a58.8 58.8 0 0 0 21.051-30.697 58.92 58.92 0 0 0-1.584-37.219"
    />
    <path
      fill="#FC6D26"
      d="m240.129 104.835-.313-.835a106.5 106.5 0 0 0-42.462 19.115L128 175.6l44.16 33.4 48.392-36.248.134-.104a58.7 58.7 0 0 0 21.039-30.656 58.73 58.73 0 0 0-1.596-37.157"
    />
    <path
      fill="#FCA326"
      d="m84 209.21 23.989 17.925 14.574 10.897A9.92 9.92 0 0 0 128.5 240a9.92 9.92 0 0 0 5.937-1.968l14.574-10.897L173 209.21 128.56 176z"
    />
    <path
      fill="#FC6D26"
      d="M58.665 123.103A106.45 106.45 0 0 0 16.201 104l-.328.82a58.73 58.73 0 0 0-1.596 37.173 58.7 58.7 0 0 0 21.061 30.665l.12.089.268.209L83.793 209 128 175.596z"
    />
  </svg>
);
export default SvgGitlab;
